export enum EUserType {
  Admin = "Admin",
  Dealer = "Dealer",
}

export default EUserType;
